const reviewsData = [
  {
    id: 1,
    name: "Mary John",
    image: "img/nat-8.jpg",
    caption: "I had a great time with my family",
    review: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis
    aperiam harum vero nostrum odio? Ipsam eum fuga et sint ipsum,
    porro, libero distinctio optio aspernatur blanditiis provident
    quidem a quia! libero distinctio optio aspernatur blanditiis
    provident quidem a quia!`,
  },
  {
    id: 2,
    name: "John Doe",
    image: "img/nat-9.jpg",
    caption: "Amazing Experience",
    review: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis
    aperiam harum vero nostrum odio? Ipsam eum fuga et sint ipsum,
    porro, libero distinctio optio aspernatur blanditiis provident
    quidem a quia! libero distinctio optio aspernatur blanditiis
    provident quidem a quia!`,
  },
];

export default reviewsData;
